module.exports = __webpack_public_path__ + "static/images/components/Warning/images/warning.6582758b.png";


//////////////////
// WEBPACK FOOTER
// ./components/Warning/images/warning.png
// module id = 2734
// module chunks = 11